import { configureStore } from "@reduxjs/toolkit";
import { HomeSlice } from "./Redux/Features/Home/HomeSlice";
import { setupListeners } from "@reduxjs/toolkit/query";

export const Store = configureStore({
  reducer: {
    [HomeSlice.reducerPath]: HomeSlice.reducer,
  },
  middleware: (curryGetDefaultMiddleware) =>
    curryGetDefaultMiddleware().concat(HomeSlice.middleware),
});

setupListeners(Store.dispatch);

export type RootState = ReturnType<typeof Store.getState>;
